import { useEffect, useRef } from "react";
import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow, StyledSectionHeading } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import useActiveWarrant from "@/hooks/useActiveWarrant";

const WarrantCourtInformation = () => {
  const [form] = Form.useForm();
  const { activeWarrant, bookingsFieldsEnabled, patch } = useActiveWarrant();
  const debounceDocket = useRef(null);

  // Hydrate form only when the warrant itself changes, not on every patch
  useEffect(() => {
    if (!activeWarrant) return;
    form.setFieldsValue({
      courtNameId:  activeWarrant?.courtNameId  ?? undefined,
      courtNumber: activeWarrant?.courtNumber ?? "",
      judgeName:    activeWarrant?.judgeName    ?? undefined,
      jurisdiction: activeWarrant?.jurisdiction ?? "",
    });
  }, [activeWarrant?.warrantId]);

  // Cleanup debounce timer on unmount
  useEffect(() => {
    return () => { if (debounceDocket.current) clearTimeout(debounceDocket.current); };
  }, []);

  const patchField = (key, val) => patch({ [key]: val });

  const patchDocket = (val) => {
    if (debounceDocket.current) clearTimeout(debounceDocket.current);
    debounceDocket.current = setTimeout(() => patch({ courtNumber: val }), 300);
  };

  const judgeOptions      = getOptionsFromRefList("Judge List", false, true);
  const jurisdictionOptions = getOptionsFromRefList("Jurisdiction");

  return (
    <>
      <StyledSectionHeading marginTop="24px">
        <span>Court Information</span>
      </StyledSectionHeading>

      <Form form={form} disabled={!bookingsFieldsEnabled}>
        <StyledGridRow gutter={16}>
          <StyledGridCol lg={5}>
            <FormItem label="Court" name="courtNameId">
              <Select
                options={getOptionsFromRefList("CourtName", false, false, true)}
                placeholder="Court"
                variant="outlined"
                onChange={(v) => patchField("courtNameId", v?.value ?? v)}
                disabled={!bookingsFieldsEnabled}
                className="address-select--pink"
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol>
            <FormItem label="Court #" name="courtNumber">
              <TextField onChange={(e) => patchDocket(e.target.value)} />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={6}>
            <FormItem label="Judge" name="judgeName">
              <Select
                options={judgeOptions}
                placeholder="Judge"
                variant="outlined"
                disabled={!bookingsFieldsEnabled}
                onChange={(v) => {
                  const selectedJudge = judgeOptions.find((item) => item.value === v);
                  patchField("judgeName", selectedJudge?.label ?? v);
                }}
              />
            </FormItem>
          </StyledGridCol>

          <StyledGridCol lg={6}>
            <FormItem label="Jurisdiction" name="jurisdiction">
              <Select
                options={jurisdictionOptions}
                placeholder="Jurisdiction"
                variant="outlined"
                onChange={(v) => patchField("jurisdiction", v?.value ?? v)}
                disabled={!bookingsFieldsEnabled}
              />
            </FormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </>
  );
};

export default WarrantCourtInformation;
